export default "__VITE_ASSET__DNBO4eIb__"